import { MessageModalLayout, Text } from '@wix/design-system';
import React from 'react';
export const StopGeneratingConfirmationModal = _ref => {
  let {
    onContinue,
    onStop,
    translations
  } = _ref;
  return /*#__PURE__*/React.createElement(MessageModalLayout, {
    closeButtonProps: {
      onClick: onContinue
    },
    content: /*#__PURE__*/React.createElement(Text, null, translations.content),
    primaryButtonOnClick: onContinue,
    primaryButtonText: translations.continueButtonText,
    secondaryButtonOnClick: onStop,
    secondaryButtonText: translations.stopButtonText,
    theme: "standard",
    title: translations.title
  });
};
//# sourceMappingURL=stop-generating-confirmation-modal.js.map